import { Stack, Box, Card, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import Paperless from '../../../assets/icons/Paperless';
import colors from '../../../constants/colors';
import useAnalytics from '../../../hooks/useAnalytics';
import { TextButton } from '../../styledComponents/Button';

const PaperlessCard = () => {
  const { track } = useAnalytics();
  return (
    <Card
      data-testid="paperlessCard"
      component={Stack}
      spacing={4}
      sx={{
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
        p: { mobile: 2, tablet: 3, desktop: 2 },
        borderRadius: 2,
        height: 'auto',
      }}
    >
      <Stack
        direction={{ mobile: 'column', tablet: 'row', desktop: 'column' }}
        spacing={{ mobile: 2, tablet: 3, desktop: 2 }}
      >
        <Box
          sx={{
            backgroundColor: colors.csaaGray,
            borderRadius: 1,
            width: { mobile: 1, tablet: '50%', desktop: 1 },
            textAlign: 'center',
            py: 1,
          }}
        >
          <Paperless />
        </Box>
        <Stack spacing={1} width={1}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              fontSize: { mobile: 16, tablet: 18 },
              lineHeight: '25px',
              fontFamily: 'Cabin',
              fontKerning: 'normal',
              color: colors.csaaBlack,
            }}
          >
            Paperless is one more way to go green
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: 16,
              lineHeight: '21px',
              fontFamily: 'Cabin',
              fontKerning: 'normal',
              color: colors.csaaDark,
            }}
          >
            If you haven’t already, set your paperless preferences to get emails
            or text alerts when bills and policy documents are available online
            to view or print.
          </Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-end"
          width={{ mobile: 1, tablet: '50%', desktop: 1 }}
        >
          <TextButton
            component={Link}
            to="/preferences"
            onClick={() =>
              track('Communication Preferences Accessed', {
                event_type: 'Link Accessed',
                link: 'Go paperless',
                location: 'Secondary Card',
              })
            }
            sx={{
              p: 1,
            }}
          >
            Go paperless
          </TextButton>
        </Stack>
      </Stack>
    </Card>
  );
};

export default PaperlessCard;
